import React from "react";
import PublicLayout from "../../../layouts/user/PublicLayout";
import ListFeature from "../../../components/user/Feature/ListFeature";

function Feature() {
	return (
		<PublicLayout
			title="Fitur"
			subtitle="Fitur unggulan Jogja Madrasah Digital"
		>
			<ListFeature />
		</PublicLayout>
	);
}

export default Feature;
